export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10448.92779c41.jpg";